var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bind-page" },
    [
      _c("GSHeader", { attrs: { text: _vm.getHeaderText() } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "main-panel",
          class: { "wide-panel": _vm.widerPanel() }
        },
        [
          _c("router-view", {
            on: {
              "show-policy": _vm.showPolicyPopup,
              "show-loading": _vm.showLoadingToast,
              "show-warning": _vm.showWarningToast
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPolicy
        ? _c(
            "GSPopup",
            {
              attrs: { title: _vm.$t("title__user_agreement") },
              on: {
                closed: function($event) {
                  _vm.showPolicyPopup(false)
                }
              }
            },
            [
              _c("div", {
                staticClass: "policy-content",
                attrs: { slot: "content" },
                domProps: { innerHTML: _vm._s(_vm.policyContent) },
                slot: "content"
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("GSToastWarn", {
        attrs: { text: _vm.toastText, type: "warn", show: _vm.showWarning },
        on: {
          clicked: function($event) {
            _vm.warningClicked()
          }
        }
      }),
      _vm._v(" "),
      _c("GSToastLoading", {
        attrs: { text: "Loading...", show: _vm.showLoading }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46feedde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46feedde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bind/BasePage.vue
// module id = null
// module chunks = 